import { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from '../store/hooks';
import { 
  fetchUserPreferences, 
  updateUserPreferences, 
  updateNavigationLayout,
  clearPreferences 
} from '../store/slices/preferencesSlice';

export const usePreferences = () => {
  const { preferences, isLoading, error } = useAppSelector((state) => state.preferences);
  const dispatch = useAppDispatch();

  const loadPreferences = useCallback(async () => {
    return dispatch(fetchUserPreferences());
  }, [dispatch]);

  const updatePreferences = useCallback(async (newPreferences: Partial<typeof preferences>) => {
    return dispatch(updateUserPreferences(newPreferences));
  }, [dispatch]);

  const changeNavigationLayout = useCallback(async (layout: 'header' | 'sidebar') => {
    // Update locally first for immediate UI response
    dispatch(updateNavigationLayout(layout));
    
    // Then save to database and return the promise
    return dispatch(updateUserPreferences({ navigationLayout: layout }));
  }, [dispatch]);

  const clearUserPreferences = useCallback(() => {
    dispatch(clearPreferences());
  }, [dispatch]);

  return {
    preferences,
    isLoading,
    error,
    loadPreferences,
    updatePreferences,
    changeNavigationLayout,
    clearUserPreferences,
  };
};
